import script from "./redis.vue?vue&type=script&setup=true&lang=js"
export * from "./redis.vue?vue&type=script&setup=true&lang=js"

import "./redis.vue?vue&type=style&index=0&id=15fbbbdf&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15fbbbdf"]])

export default __exports__